<div class="profile-evidence-backdrop" (click)="close()">
  <section #dialog class="profile-evidence-dialog" role="dialog" aria-modal="true" [attr.aria-labelledby]="headingId" (click)="$event.stopPropagation()" (keydown)="onKeydown($event)">
    <header>
      <div>
        <span class="profile-evidence-dialog__eyebrow">{{ eyebrow }}</span>
        <h2 [id]="headingId">{{ heading }}</h2>
        @if (subtitle) {<p class="profile-evidence-dialog__subtitle">{{ subtitle }}</p>}
      </div>
      <button #closeButton type="button" (click)="close()" [attr.aria-label]="closeLabel"><i class="fal fa-xmark" aria-hidden="true"></i></button>
    </header>
    <div class="profile-evidence-dialog__body">
      <h3>{{ answerHeading }}</h3>
      @if (detailRows) {
        <dl class="profile-evidence-dialog__answer">@for (detail of detailRows; track $index) {<div><dt>{{ detail.label }}</dt><dd>{{ detail.value }}</dd></div>}</dl>
      } @else {
        <div class="profile-evidence-dialog__formatted"><ng-content select="[evidenceAnswer]"></ng-content></div>
      }
      @if (detailedReferences) {
        <p class="profile-evidence-dialog__meta">
          <span><i class="fas fa-circle" [style.color]="confidenceColour(response?.confidence)" aria-hidden="true"></i> {{ confidenceLabel(response?.confidence) }}</span>
          @if (response?.date_generated) {<span>Generated {{ formatDate(response.date_generated) }}</span>}
        </p>
      } @else {
        <p class="profile-evidence-dialog__confidence">{{ confidenceLabel(response?.confidence) }}</p>
      }
      @if (response?.question) {<h3>Question asked</h3><p>{{ response.question }}</p>}
      @if (response?.commentary) {<h3>{{ commentaryHeading }}</h3><p>{{ response.commentary }}</p>}
      <h3>{{ referencesHeading }}@if (detailedReferences && references.length) { <span class="profile-evidence-dialog__count">{{ references.length }}</span>}</h3>
      @if (references.length) {
        @for (reference of references; track $index) {
          <blockquote>
            @if (reference.quote) {<p>“{{ reference.quote }}”</p>}
            @if (reference.key_info) {<p [class.profile-evidence-dialog__key-info]="detailedReferences && reference.quote">{{ reference.key_info }}</p>}
            @if (detailedReferences) {
              <footer class="profile-evidence-dialog__source">
                <span class="profile-evidence-dialog__source-type">{{ sourceLabel(reference.source) }}</span>
                @if (reference.date) {<span>{{ formatDate(reference.date) }}</span>}
                @if (reference.is_verified) {<span class="profile-evidence-dialog__verified"><i class="fal fa-badge-check" aria-hidden="true"></i> Quote matched to source</span>}
                @if (safeUrl(reference.url); as url) {<a [href]="url" target="_blank" rel="noopener noreferrer">Open source <i class="fal fa-arrow-up-right" aria-hidden="true"></i><span class="sr-only"> (opens in a new tab)</span></a>}
                @else {<span class="profile-evidence-dialog__no-link">No link supplied</span>}
              </footer>
            } @else {
              <footer>@if (reference.url) {<a [href]="reference.url" target="_blank" rel="noopener noreferrer">{{ reference.source || reference.url }} <i class="fal fa-arrow-up-right" aria-hidden="true"></i></a>} @else {<span>{{ reference.source || 'Source unavailable' }}</span>}</footer>
            }
          </blockquote>
        }
      } @else {<p>No source quotes were supplied for this answer.</p>}
    </div>
  </section>
</div>
